<!-- 收款账户 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="typeList" :multiple="config.multiple" :placeholder="placeholder" :clearable="clearable">
      <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-收款账户选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '收款账户：',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const types = ref([]);

    let typeList = ref([]);
    const api = inject('api');
    async function getAccount() {
      const res = await api.customPaymentAccount({
        page: {
          pageNum: 1,
          pageSize: 999,
        },
        status: 1,
      });
      types.value = res.data;
    }
    getAccount();

    function reset() {
      typeList.value = props.value;
    }

    typeList = useQuery('customAccount', props.value, reset);

    return {
      reset,
      types,
      typeList,
    };
  },
};
</script>
